import { render, staticRenderFns } from "./avg-messages-per-session.vue?vue&type=template&id=7cdf31f8&scoped=true&"
import script from "./avg-messages-per-session.vue?vue&type=script&lang=js&"
export * from "./avg-messages-per-session.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdf31f8",
  null
  
)

export default component.exports